export const rendererPageInfo = function (option, callback) {

    let dom = $(option.domId, option.pdom);
    dom.empty();
    if (option.totalCount != 0) {

        const totalPageNo = Math.ceil(option.totalCount / option.pg_rowsize);

        const pageGroup = Math.ceil(option.pageNo / option.pageCountOfGroup);
        const endPageGroup = Math.ceil(totalPageNo / option.pageCountOfGroup);

        const startPageOfGroup = (pageGroup - 1) * option.pageCountOfGroup + 1;
        let endPageOfGroup = pageGroup * option.pageCountOfGroup;
        endPageOfGroup = endPageOfGroup > totalPageNo ? totalPageNo : endPageOfGroup;

        const startRowNum = (option.pageNo - 1) * option.pg_rowsize + 1;
        let endRowNum = option.pageNo * option.pg_rowsize;
        endRowNum = endRowNum > option.totalCount ? option.totalCount : endRowNum;

        let html = "";
        html += "<a class='page direction first'><span></span></a>";
        html += "<a class='page direction prev'><span></span></a>";

        for (let i = startPageOfGroup; i <= endPageOfGroup; i++) {
            if (option.pageNo === i) {
                html += "<strong class='current'>" + i + "</strong>";
            } else {
                html += "<a class='pgnum'>" + i + "</a>";
            }
        }

        html += "<a class='page direction next'><span></span></a>";
        html += "<a class='page direction last'><span></span></a>";

        dom.html(html);

        // FIRST
        dom.find("a.first").on("click", function(e) {
            if (option.pageNo > 1) {
                let pageNo = 1;
                option.pageNo = pageNo;

                rendererPageInfo(option, callback);
                callback(pageNo);
            }
        });

        // PREV
        dom.find("a.prev").on("click", function(e) {
            if (pageGroup > 1) {
                let pageNo = startPageOfGroup - 1;
                option.pageNo = pageNo;

                rendererPageInfo(option, callback);
                callback(pageNo);
            }

            /*let currentNo = dom.find("a.current").text();
            if(currentNo > 1){
                currentNo --;
                option.pageNo = currentNo;

                _self.rendererPageInfo(option, callback);
                callback(currentNo);
            }*/
        });

        // NEXT
        dom.find("a.next").on("click", function(e) {
            if (pageGroup < endPageGroup) {
                let pageNo = endPageOfGroup + 1;
                option.pageNo = pageNo;

                rendererPageInfo(option, callback);
                callback(pageNo);
            }

            /*let currentNo = dom.find("a.current").text();
            if(currentNo < totalPageNo) {
                currentNo++;
                option.pageNo = currentNo;

                _self.rendererPageInfo(option, callback);
                callback(currentNo);
            }*/
        });

        // LAST
        dom.find("a.last").on("click", function(e) {
            if (option.pageNo < totalPageNo) {
                let pageNo = totalPageNo;
                option.pageNo = pageNo;

                rendererPageInfo(option, callback);
                callback(pageNo);
            }
        });

        // PAGE
        dom.find("a.pgnum").on("click", function(e) {
            let pageNo = $(this).text();
            pageNo = Number(pageNo);
            option.pageNo = pageNo;

            rendererPageInfo(option, callback);
            callback(pageNo);
        });
    }

};